import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import SingleConfigFieldOptions from '../../../UserWidgets/_partials/WidgetEditControls/SingleConfigFieldOptions';
import ConfigPopover from '../../../UserWidgets/_partials/ConfigPopover';

import s from './UserGridConfigPopover.scss';

export interface Props {
  moduleId: number;
  withManageLink?: boolean;
  onClose(): void;
}

export const UserGridConfigPopover: React.FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <ConfigPopover withPaddings={false} onClose={props.onClose} width={230}>
      {props.withManageLink && (
        <Button
          target="_blank"
          href="/watching"
          className={s['manage-button']}
          view="b14"
          height="medium"
        >
          {t('widgets.userGrid.editWatchList')}
        </Button>
      )}
      <SingleConfigFieldOptions
        moduleId={props.moduleId}
        paramName="sortBy"
        labels={{
          newest: 'common.sortOrder.newest',
          oldest: 'common.sortOrder.oldest',
        }}
        close={props.onClose}
      />
    </ConfigPopover>
  );
};
UserGridConfigPopover.displayName = 'UserGridConfigPopover';

export default UserGridConfigPopover;
